import { atom } from 'recoil';

export const createdTimeSearchDialogOpenState = atom({
    key: 'createdTimeSearchDialogOpenSate',
    default: false,
});
